import { Button } from "@ui/Button";
import { Show } from "solid-js";
import type { VideoEvidence } from "~/modules/shared/chat/ChatEventTypes";

type Props = {
	activeSlide: number;
	setActiveSlide: (slide: number) => void;
	videoEvidence: VideoEvidence[];
};

export const ScrollButtons = (props: Props) => {
	return (
		<Show when={props.videoEvidence.length > 1}>
			<div class="video-panel-carousel__nav">
				<Button
					aria-label="Previous video"
					symbol="chevron_left"
					variant="primary"
					size="large"
					theme="black"
					shape="circle"
					disabled={props.activeSlide === 0}
					onClick={() => props.setActiveSlide(props.activeSlide - 1)}
				/>
				<Button
					aria-label="Next video"
					symbol="chevron_right"
					variant="primary"
					size="large"
					theme="black"
					shape="circle"
					disabled={props.activeSlide === props.videoEvidence.length - 1}
					onClick={() => props.setActiveSlide(props.activeSlide + 1)}
				/>
			</div>
		</Show>
	);
};
